import { SVGProps } from 'react'
const CircleIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="Icon/ (16px)">
      <g id="Group 2693">
        <path
          id="Loader Background"
          d="M14 8C14 8.78793 13.8448 9.56815 13.5433 10.2961C13.2417 11.0241 12.7998 11.6855 12.2426 12.2426C11.6855 12.7998 11.0241 13.2417 10.2961 13.5433C9.56815 13.8448 8.78793 14 8 14C7.21207 14 6.43185 13.8448 5.7039 13.5433C4.97595 13.2417 4.31451 12.7998 3.75736 12.2426C3.20021 11.6855 2.75825 11.0241 2.45672 10.2961C2.15519 9.56815 2 8.78793 2 8H3.68C3.68 8.56731 3.79174 9.12907 4.00884 9.65319C4.22594 10.1773 4.54415 10.6536 4.9453 11.0547C5.34645 11.4559 5.82268 11.7741 6.34681 11.9912C6.87093 12.2083 7.43269 12.32 8 12.32C8.56731 12.32 9.12907 12.2083 9.65319 11.9912C10.1773 11.7741 10.6536 11.4559 11.0547 11.0547C11.4559 10.6536 11.7741 10.1773 11.9912 9.65319C12.2083 9.12907 12.32 8.56731 12.32 8H14Z"
          fill="#333333"
          {...(props.color && { fill: props.color })}
        />
        <path
          id="Loader Fill"
          d="M10.766 2.67558C9.85121 2.20038 8.82946 1.96887 7.79922 2.00336C6.76898 2.03786 5.765 2.3372 4.88408 2.87252C4.00316 3.40785 3.27502 4.1611 2.76986 5.05965C2.2647 5.95821 1.99956 6.97176 2 8.00258L3.68 8.00186C3.67968 7.25967 3.87058 6.52991 4.2343 5.88295C4.59801 5.23599 5.12228 4.69365 5.75654 4.30822C6.3908 3.92278 7.11366 3.70726 7.85544 3.68242C8.59721 3.65758 9.33287 3.82427 9.9915 4.16642L10.766 2.67558Z"
          fill="#333333"
          {...(props.color && { fill: props.color })}
        />
        <path
          id="Loader Fill_2"
          d="M12.2426 12.2426C12.9122 11.5731 13.4137 10.7546 13.7063 9.8541C13.9989 8.95358 14.0743 7.9966 13.9261 7.06139C13.778 6.12619 13.4107 5.23932 12.8541 4.47329C12.2976 3.70726 11.5676 3.08383 10.7239 2.65396L9.96124 4.15085C10.5687 4.46035 11.0942 4.90923 11.495 5.46077C11.8957 6.01231 12.1602 6.65086 12.2668 7.3242C12.3735 7.99755 12.3192 8.68658 12.1086 9.33495C11.8979 9.98333 11.5368 10.5726 11.0547 11.0547L12.2426 12.2426Z"
          fill="#333333"
          {...(props.color && { fill: props.color })}
        />
      </g>
    </g>
  </svg>
)
export default CircleIcon
